import { Component } from 'react'
import { connect } from '../../../lib/keaConnect'
import auth from '@otavamedia/om-component-library/lib/kea/auth'
import querystring from 'querystring'
import PropTypes from 'prop-types'

@connect({
  actions: [
    auth, [
      'remoteLogin',
    ],
  ]
})
export default class RemoteLogin extends Component {
  static propTypes = {
    actions: PropTypes.object,
  }

  constructor (props) {
    super(props)
    const qs = querystring.parse(window.location.search.substring(1))
    props.actions.remoteLogin(qs.username, qs.token)
  }

  render () {
    return null
  }
}
